import React, { useState } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./CustomerList.css";

const LS_KEY = "app_users_v1";

function saveUserToLocalStorage(user) {
  const existing = JSON.parse(localStorage.getItem(LS_KEY)) || [];
  const nextId = existing.length ? Math.max(...existing.map(u => u.id)) + 1 : 1;
  const newUser = { ...user, id: nextId };
  localStorage.setItem(LS_KEY, JSON.stringify([...existing, newUser]));
}

const AddPrivilegeUser = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Double-check in JS, although required fields will prevent empty submission
    if (!formData.name || !formData.designation || !formData.email) {
      alert("Please fill all fields");
      return;
    }

    const newUser = {
      ...formData,
      privileges: {},
    };

    saveUserToLocalStorage(newUser);
    navigate("/settings"); // go back after saving
  };

  return (
    <Container className="my-4">
      <div className="form-header mb-4 d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Add Privilege User</h4>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <Form onSubmit={handleSubmit}>
        <Row className="g-3">
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter name"
                required
              />
            </Form.Group>
          </Col>

          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Designation</Form.Label>
              <Form.Control
                type="text"
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                placeholder="Enter designation"
                required
              />
            </Form.Group>
          </Col>

          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter email"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="form-actions mt-4 d-flex justify-content-end gap-2">
          <Button type="submit" className="btn-submit">
            Save
          </Button>
          <Button variant="outline-secondary" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default AddPrivilegeUser;
